import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import CloseIcon from '../../SVG/CloseIcon';
import { CampaignGreenIconSVG } from '../../SVG/CampaignGreenIconSVG';

import TemplateDeleteConfirm from './TemplateDeleteConfirm';

const TemplateModal = ({ show, onClose, saveTemplate, campaign_form_fields, setCampaignFormFields, deleteTemplate }) => {

  const { template_name, message_content, selected_template } = campaign_form_fields;

  const [templateNameError, setTemplateNameError] = useState('');
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const handleCampaignFormFieldsChange = (field, value) => {
    setCampaignFormFields((prevFields) => ({
      ...prevFields,
      [field]: value,
    }));
  };

  const handleSaveTemplate = (alertmessage) => {
    if (template_name.length < 3) return setTemplateNameError('Template Name should have a minimum length of 3 characters.');
    if (template_name.length >= 3) setTemplateNameError('');
    saveTemplate(alertmessage);
  };

  const handleDeleteTemplate = () => {
    onClose();
    setDeleteModalShow(true);
  };

  const confirmDeleteTemplate = () => {
    deleteTemplate();
    setDeleteModalShow(false);
    onClose();
  };

  return (
    <>
      <Modal show={show} className="modal-delete" animation={true} centered>
        <Modal.Body>
          <CloseIcon handleModalClose={onClose} />
          <CampaignGreenIconSVG type={selected_template?.id === undefined ? "create" : "edit"} />
          <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
            {selected_template?.id ? "Edit Message Template" : "Create New Message Template"}
          </Modal.Title>
          <Form.Group>
            <Form.Label>Message Template Name</Form.Label>
            <Form.Control
              placeholder="Your Template Name"
              value={template_name}
              onChange={(evt) => handleCampaignFormFieldsChange("template_name", evt.target.value)}
              isInvalid={templateNameError}
            />
            {templateNameError && (
              <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                {templateNameError}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group>
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              value={message_content}
              placeholder="Your Message Content"
              onChange={(evt) => handleCampaignFormFieldsChange("message_content", evt.target.value)}
            />
          </Form.Group>
          <div>
            {selected_template?.id ? (
              <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
                <Button
                  variant="danger"
                  style={{ minWidth: 160 }}
                  onClick={handleDeleteTemplate} // Show delete confirmation modal
                >
                  Delete Template
                </Button>
                <Button
                  variant="primary"
                  style={{ minWidth: 160 }}
                  onClick={() => {
                    handleSaveTemplate("Message Template updated successfully");
                  }}
                >
                  Save
                </Button>
              </div>
            ) : (
              <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
                <Button
                  variant="ghost"
                  style={{ minWidth: 160 }}
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  style={{ minWidth: 160 }}
                  onClick={() => {
                    handleSaveTemplate("Message Template created successfully");
                  }}
                >
                  Save
                </Button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <TemplateDeleteConfirm
        show={deleteModalShow}
        onClose={() => setDeleteModalShow(false)}
        onConfirm={confirmDeleteTemplate}
        templateName={template_name}
      />
    </>
  );
};

export default TemplateModal;